module.exports = __webpack_public_path__ + "static/media/right-way.d419fa74.PNG";